import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { useLinkedProjects } from "@/hooks/Network/useLinkedProjects";
import { useQueryParam } from "@/hooks/useQueryParam";
import { useAlertQueries } from "@/queries/alerts/queryOptions";

import { AlertsList, type AlertsListProps } from "./AlertsList";

const PAGE_SIZE = 30;

export function ListAlertsPage(): React.ReactNode {
  const alertQueries = useAlertQueries();

  const [projectId, setProjectId] = useQueryParam<string>("tab");
  const [previousProjectId, setPreviousProjectId] = useState(projectId);
  const [page, setPage] = useQueryParam("page");

  const pageNumber = (Number(page) || 1) - 1;
  const query = {
    Offset: pageNumber * PAGE_SIZE,
    Limit: PAGE_SIZE,
  };

  const { data: projects = [], isPending: isLoadingProjects } = useLinkedProjects();
  const {
    data: triggeredAlerts,
    isPending: isLoadingAlerts,
    error: alertsError,
  } = useQuery(alertQueries.triggeredList(query, projectId));

  const error = alertsError;
  if (error) {
    return <ErrorPage error={error} />;
  }

  const totalPages = triggeredAlerts ? Math.ceil(triggeredAlerts.total / PAGE_SIZE) : 0;

  const contentProps: AlertsListProps = {
    triggeredAlerts: triggeredAlerts?.items || [],
    isLoading: isLoadingAlerts || isLoadingProjects,
    pageIndex: pageNumber,
    projects,
    onPageChange: (page) => setPage((page + 1).toString()),
    totalPages,
    projectId: projectId || undefined,
    previousProjectId: previousProjectId || undefined,
    onProjectChange: (x) => {
      setPreviousProjectId(projectId);
      setProjectId(x || null);
    },
  };

  return <AlertsList {...contentProps} />;
}
